import Vue from "vue";

export default {
  /**
   *  查询学生的功能区教室入口
   * @param params
   * @param config
   * @returns {Promise<AxiosResponse<T>>}
   */
  async getClassRoom(params = {}, config = {}) {
    config.params = params;
    // let result = await Vue.http.get('/lwtpk-web/area',  config)
    let result = await Vue.http.get(
      "/lwtpk-web/classroom/list/area-class-room/student",
      config
    );

    return result;
  },

  /**
   * 根据教室ID查询所有的父节点（包括父级功能区和本身）
   * @param params
   * @param config
   * @returns {Promise<AxiosResponse<T>>}
   */
  async getPlayHeader(params = {}, config = {}) {
    config.params = params;
    let result = await Vue.http.get(
      "/lwtpk-web//classroom/list/parent/area-class-room",
      config
    );
    return result;
  },
  /**
   * 获取指定功能区的摄像头的播放地址
   * @param params
   * @param config
   * @returns {Promise<AxiosResponse<T>>}
   */
  async getPlayUrls(params = {}, config = {}) {
    config.params = params;
    let result = await Vue.http.get("/lwtpk-web/classroom/playUrls", config);
    return result;
  },

  /**
   * 获取教室的摄像头列表
   * @param params
   * @param config
   * @returns {Promise<AxiosResponse<any>>}
   */
  async getClassRoomCameras(params = {}, config = {}) {
    config.params = params;
    let result = await Vue.http.get("/lwtpk-web/classroom/cameras", config);
    return result;
  },

  async streamCMS(params = {}, config = {}) {
    // config.params = params;
    let result = await Vue.http.get("/lw-stream-cms" + params, config);
    return result;
  },
  /**
   * 获取学生选中教室的当前或者下节课的直播
   * @param {*} params
   * @param {*} config
   */
  async getStudentCurrentOrNextLiveByClassRoom(params = {}, config = {}) {
    config.params = params;
    let result = await Vue.http.get("/lwtpk-web/live/course/student-classroom", config);
    return result;
  },

  /**
   * 获取学生选中教室的当前或者下节课的直播
   * @param {*} params
   * @param {*} config
   */
  async getStudentCurrentOrNextLiveBySchedule(params = {}, config = {}) {
    config.params = params;
    let result = await Vue.http.get("/lwtpk-web/live/course/student-schedule", config);
    return result;
  },
  /**
   * 获取该节课信息
   * @param params
   * @param config
   * @returns {Promise<*>}
   */
  async getCourseMaterials(params = {}, config = {}) {
    config.params = params;
    let result = await Vue.http.get("/lwtpk-web/course/material", config);
    return result;
  },

  /**
   *   获取班级正在使用的摄像头和摄像头的播放地址
   * @param params
   * @param config
   * @returns {Promise<AxiosResponse<T>>}
   */
  async getCameras(params = {}, config = {}) {
    // config.params = params;
    let result = await Vue.http.get("/lwtpk-web/organization/cameras/" + params.id + "?gardenId=" + params.gardenId, config);
    return result;
  },

  /**
   * 获取备课资料
   * @param params
   * @param config
   * @returns {Promise<*>}
   */
  async getMaterial(params = {}, config = {}) {
    config.params = params;
    let result = await Vue.http.get("/lwtpk-web/course/material/item", config);
    return result;
  },

  async getVideoUrl(params = {}, config = {}) {
    // config.params = params;
    const result = await Vue.http.get("/lwtpk-web/streamMedia/playPath/" + params.gardenId + "?filename=" + params.filename, config);
    return result;
  },

  /**
   * 获取当前时间所在的学年学期和周次
   */
  async getCurrent(params = {}, config = {}) {
    config.params = params;
    const result = await Vue.http.get("/lwtpk-web/time/current", config);
    return result;
  },

  /**
   * 获取课表中得到的学年列表
   */
  async getScheduleYearList(params = {}, config = {}) {
    config.params = params;
    const result = await Vue.http.get("/lwtpk-web/schedule/teacher/years", config);
    return result;
  },

  /**
   * 获取课表的学年下学期列表
   * @param params
   * @param config
   * @returns {Promise<AxiosResponse<any>>}
   */
  async getScheduleSemesterList(params = {}, config = {}) {
    config.params = params;
    const result = await Vue.http.get("/lwtpk-web/schedule/teacher/semesters", config);
    return result;
  },

  /**
   * 获取选择学期下的周次列表
   * @param params
   * @param config
   * @returns {Promise<AxiosResponse<any>>}
   */
  async getWeekList(params = {}, config = {}) {
    config.params = params;
    const result = await Vue.http.get("/lwtpk-web/schedule/teacher/weeks", config);
    return result;
  },

  /**
   * 获取学生选定周次有课表安排的年级班级
   * @param params
   * @param config
   * @returns {Promise<AxiosResponse<any>>}
   */
  async getClassList(params = {}, config = {}) {
    config.params = params;
    const result = await Vue.http.get("/lwtpk-web/schedule/teacher/all/classes", config);
    return result;
  },

  /**
   * 获取指定条件下的课节信息
   * @param params
   * @param config
   * @returns {Promise<AxiosResponse<any>>}
   */
  async getLessons(params = {}, config = {}) {
    config.params = params;
    const result = await Vue.http.get("/lwtpk-web/schedule/teacher/lessons", config);
    return result;
  },

  /**
   * 获取已录课节
   *
   * @param params
   * @param config
   * @returns {Promise<AxiosResponse<any>>}
   */
  async listUnicastCourse(params = {}, config = {}) {
    config.params = params;
    const result = await Vue.http.get("/lwtpk-web/unicast/course/permission", config);
    return result;
  },

  /**
   * 获取点播的播放记录
   * @param params
   * @param config
   * @returns {Promise<AxiosResponse<any>>}
   */
  async getUnicastCoursePlayUrl(params = {}, config = {}) {
    const result = await Vue.http.get("/lwtpk-web/unicast/course/playurl/" + params.unicastCourseId, config);
    return result;
  },

  /**
   * 获取摄像头的播放地址
   * @param params
   * @param config
   * @returns {Promise<AxiosResponse<any>>}
   */
  async getCameraPlayUrl(params = {}, config = {}) {
    config.params = params;
    const result = await Vue.http.get("/lwtpk-web/camera/play-url", config);
    return result;
  },

  /**
   * 获取视频播放地址接口
   * @param params
   * @param config
   * @returns {Promise<AxiosResponse<T>>}
   */
  async getStreamMediaPlayUrl(params = {}, config = {}) {
    // config.params = params;
    const result = await Vue.http.get(`lwtpk-web/streamMedia/playPath/${params.gardenId}?filename=${params.filename}`);
    return result;
  }

};
